// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notes_notes__1zIkj {
    padding: 10px;
    border-bottom: 0;
    border: 1px solid var(--color-126);
    background-color: var(--color-104);
    min-height: 160px;
}

.Notes_notesHeader__TCA\\+k h3 {
    font-size: 17px;
    font-weight: 100;
    line-height: inherit;
    text-overflow: ellipsis;
}

.Notes_notesFooter__zHvZ- {
    min-height: 35px;
    margin: 9px 0 0 0; 
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Notes/Notes.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,kCAAkC;IAClC,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".notes {\n    padding: 10px;\n    border-bottom: 0;\n    border: 1px solid var(--color-126);\n    background-color: var(--color-104);\n    min-height: 160px;\n}\n\n.notesHeader h3 {\n    font-size: 17px;\n    font-weight: 100;\n    line-height: inherit;\n    text-overflow: ellipsis;\n}\n\n.notesFooter {\n    min-height: 35px;\n    margin: 9px 0 0 0; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notes": `Notes_notes__1zIkj`,
	"notesHeader": `Notes_notesHeader__TCA+k`,
	"notesFooter": `Notes_notesFooter__zHvZ-`
};
export default ___CSS_LOADER_EXPORT___;
